<div mdbModal #imprimirFacturaDetalle="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Folio {{folio}}
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
          (click)="imprimirFacturaDetalle.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row" style="border-bottom: 1px solid #dee2e6;">
          <div class="col">
            <h5 class="modal-title w-100 text-left" id="myModalLabel">
              Datos cliente
            </h5>
          </div>
        </div>

        <div class="row">
          <div class="col dato">
            <Strong class="title">Rut</Strong>
            <span class="value">{{clienteRut | rut}}</span>
          </div>
          <div class="col dato">
            <Strong class="title">Nombre</Strong>
            <span class="value">{{clienteNombre}}</span>
          </div>
          <div class="col dato">
            <Strong class="title">Fecha</Strong>
            <span class="value">
              {{fechaEmision | fecha}}
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col dato">
            <Strong class="title">Dirección</Strong>
            <span class="value">{{direccionNombre}}</span>
          </div>
          <div class="col dato">
            <Strong class="title">Vendedor</Strong>
            <span class="value">{{vendedorNombre}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col mt-1">
            <div class="table-responsive">
              <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos">
                <thead class="grey lighten-2">
                  <tr>
                    <th scope="col" class="text-center" *ngIf="dataCabecera.tipo_dte_codigo != 46">SKU</th>
                    <th scope="col">Descripción</th>
                    <th scope="col" *ngIf="dataCabecera.tipo_dte_codigo != 46">Formato</th>
                    <th scope="col">Cantidad</th>
                    <th scope="col">Precio</th>
                    <th scope="col">Descuento</th>
                    <th scope="col">Recargo</th>
                    <th scope="col">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colspan="100%" style="text-align: center" *ngIf="listaMovimientos?.length === 0">
                      <span *ngIf="dataCabecera?.tipo_ncnd_codigo == 1" style="font-size: 14px;">
                        {{dataCabecera?.glosa_administrativa}}
                      </span>
                      <span *ngIf="dataCabecera?.tipo_ncnd_codigo != 1">
                        No se encontró información
                      </span>
                    </td>
                  </tr>
                  <tr *ngFor="let mov of listaMovimientos">
                    <td class="text-center" *ngIf="mov.tipo_dte_codigo != 46">{{ mov.sku }}</td>
                    <td class="text-center">{{ mov.descripcion_producto }}</td>
                    <td class="text-center" *ngIf="dataCabecera.tipo_dte_codigo != 46">{{ mov.formato_nombre }}</td>
                    <td class="text-center">{{mov.cantidad}}</td>
                    <td class="text-center">$ {{ mov.precio_unitario | numerico }}</td>
                    <td class="text-center">$ {{ mov.aplicacion_descuento | numerico }}</td>
                    <td class="text-center">$ {{ mov.aplicacion_recargo | numerico }}</td>
                    <td class="text-center">$ {{ mov.monto_total_neto | numerico }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="totalesDocumento">
          <div class="col mt-1">
            <table class="table table-striped table-hover table-sm align-middle">
              <thead class="blue lighten-5">
                <tr>
                  <th scope="col">SubTotal</th>
                  <th scope="col">Descto.</th>
                  <th scope="col">Recargo</th>
                  <th scope="col" *ngIf="dataCabecera.tipo_dte_codigo != 46">impto. Adic.</th>
                  <th scope="col">Afecto</th>
                  <th scope="col">Exento</th>
                  <th scope="col">Neto</th>
                  <th scope="col">IVA</th>
                  <th scope="col" *ngIf="dataCabecera.tipo_dte_codigo == 46">IVA RET.</th>
                  <th scope="col">TOTAL</th>
                </tr>
              </thead>
              <tbody class="blue lighten-5">
                <tr>
                  <td>$ {{ totalesDocumento.subtotal | numerico }}</td>
                  <td>$ {{ totalesDocumento.descuento | numerico }}</td>
                  <td>$ {{ totalesDocumento.recargo | numerico }}</td>
                  <td *ngIf="dataCabecera.tipo_dte_codigo != 46">
                    <span *ngIf="dataCabecera.vendedor_codigo != 0">$ {{ totalesDocumento.impto_adic | percent }}</span>
                    <span *ngIf="dataCabecera.tipo_dte_codigo == 61 && dataCabecera.vendedor_codigo == 0">$ - {{
                      totalesDocumento.iva | numerico }}</span>
                  </td>
                  <td>$ {{ totalesDocumento.afecto | numerico }}</td>
                  <td>$ {{ totalesDocumento.exento | numerico }}</td>
                  <td>$ {{ totalesDocumento.neto | numerico }}</td>
                  <td>$ {{ totalesDocumento.iva | numerico }}</td>
                  <td *ngIf="dataCabecera.tipo_dte_codigo == 46">- $ {{ totalesDocumento.iva | numerico }}</td>
                  <td>
                    <strong *ngIf="dataCabecera.tipo_dte_codigo != 46">$ {{ totalesDocumento.total | numerico
                      }}</strong>
                    <strong *ngIf="dataCabecera.tipo_dte_codigo == 46">$ {{ totalesDocumento.subtotal | numerico
                      }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
          (click)="imprimirFacturaDetalle.hide()" mdbWavesEffect>
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>
